import React from 'react';
import { TourneyEncoded } from 'modules/tournaments/domain/interfaces/tourney-encoded';
import TourneysComponentsCreateFormTabs from './tabs';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { ChampionshipInfoForm } from 'modules/championship/ui/components/championship-form';

type Props = {
  onSubmit: (data: Partial<TourneyEncoded>) => any;
};

const TourneyComponentsCreateForm = (props: Props) => {
  const { info } = useOrganizer();

  if (!info) {
    return null;
  }

  return (
    <>
      <div className="container py-6">
        <TourneysComponentsCreateFormTabs />
      </div>
      <ChampionshipInfoForm tournamentId={info!.id} />
    </>
  );
};

export default TourneyComponentsCreateForm;
